import { SearchType } from 'components/search/utils';
import { useEffect } from 'react';
import { useHasSearchQueryStringParams } from 'components/search/useHasSearchQueryStringParams';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Hook that redirects the new landing pages to the new search urls for marketing campaigns, etc.
 */
export function useSearchRedirect(type: SearchType): void {
  const history = useHistory();
  const location = useLocation();
  const hasSearchQueryStringParams = useHasSearchQueryStringParams(type);
  useEffect(() => {
    if (hasSearchQueryStringParams) {
      history.replace({
        pathname: `${location.pathname}/search`,
        search: location.search,
      });
    }
    // only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
